import React from 'react';
import Blogs from './Blogs';

const News = () => {
    return <Blogs />;
};

export default News;
